import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { store } from './store';

const app = createApp(App);

//global directives
import TrimDirective from './directives/trim';
import NumberDirective from './directives/number';
import MaxLenghtDirective from './directives/maxlength';
import KatakanaDirective from './directives/katakana';
import AlphabetDirective from './directives/alphabet';
import SpaceDirective from './directives/space';
import EmailDirective from './directives/email';
import DecimalDirective from './directives/decimal';
import HiraganaDirective from './directives/hiragana';
import AlphabetAndNumericHalfsizeDirective from './directives/alphabetAndNumericHalfsize';
import AlphaNumSpecialHalfsizeDirective from './directives/alphaNumSpecialHalfsize';
import NumberAndCommaDirective from './directives/numberAndComma';
import AlphaNumSpecialFullsize from './directives/alphaNumSpecialFullsize';
import NumberAndHypenDirective from './directives/numberAndHypen';
import AlphabetNumericAndCommaHalfsizeDirective from './directives/alphabetNumericAndCommaHalfsize';

app.directive('trim', TrimDirective);
app.directive('number', NumberDirective);
app.directive('maxlength', MaxLenghtDirective);
app.directive('katakana', KatakanaDirective);
app.directive('alphabet', AlphabetDirective);
app.directive('space', SpaceDirective);
app.directive('email', EmailDirective);
app.directive('decimal', DecimalDirective);
app.directive('hiragana', HiraganaDirective);
app.directive('alphabetAndNumericHalfsize', AlphabetAndNumericHalfsizeDirective);
app.directive('alphaNumSpecialHalfsize', AlphaNumSpecialHalfsizeDirective);
app.directive('numberAndComma', NumberAndCommaDirective);
app.directive('alphaNumSpecialFullsize', AlphaNumSpecialFullsize);
app.directive('numberAndHypen', NumberAndHypenDirective);
app.directive('alphabetNumericAndCommaHalfsize', AlphabetNumericAndCommaHalfsizeDirective);

//pageHeader
import PageHeader from './components/PageHeader.vue';
app.component('PageHeader', PageHeader);
//pageFooter
import PageFooter from './components/PageFooter.vue';
app.component('PageFooter', PageFooter);
//panel
import Panel from './components/Panel.vue';
app.component('Panel', Panel);
//action button
import ActionButton from './components/ActionButton.vue';
app.component('ActionButton', ActionButton);

import permission from '@/helpers/permission';
import message from '@/helpers/message';
import loading from '@/helpers/loading';
app.config.globalProperties.$permission = permission;
app.config.globalProperties.$message = message;
app.config.globalProperties.$loading = loading;

app.use(router).use(store).mount('#app');
